import { UntypedFormGroup, ValidationErrors } from '@angular/forms';

export const validateQrCodeFields = (formGroup: UntypedFormGroup): ValidationErrors | null => {
  const promoCode = formGroup.get('promoCode');
  const qrCodeImage = formGroup.get('qrCodeImage');
  const isPermanentCode = formGroup.get('isPermanentCode');

  if (isPermanentCode?.value && !promoCode?.value && !qrCodeImage?.value) {
    promoCode?.setErrors({ qrCodeRequired: true });

    return { qrCodeRequired: true };
  }

  return null;
};
